"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Name = "add-to-basket";
exports.AddToBasketEvent = exports.Name;
